import { getProductsContactPresentationTypes } from "../../constantes/actionTypes"

const initialState = []

export const productsContactPresentation = (state = initialState, action) => {
    switch (action.type) {
        case getProductsContactPresentationTypes.GET_PRODUCTS_CONTACT_PRESENTATION_SUCCESS:
            return action.payload
        case getProductsContactPresentationTypes.GET_PRODUCTS_CONTACT_PRESENTATION_SUCCESS:
            return initialState
        default:
            return state
    }
}